import { Component, PipeTransform, OnInit } from '@angular/core';
import { BnLoadingService, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { TarefasOperacaoService } from './tarefas-operacao.service';
import { FileUtilsService } from '../../../shared/file-utils.service';
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { Estado } from 'src/app/model/estado.model';
import { ActivatedRoute } from '@angular/router';
import { TarefasHonraService } from '../honra/tarefas-honra.service';
import moment from "moment";
import { DatePipe } from '@angular/common';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { OperacaoRepasseBndes } from 'src/app/model/operacao-repasse-bndes.model';

@Component({
    selector: 'app-tarefas-operacao',
    templateUrl: './tarefas-operacao.component.html',
    styleUrls: ['./tarefas-operacao.component.scss'],
    standalone: false
})
export class TarefasOperacaoComponent implements OnInit {

  public conteudoArquivo: string | undefined;
  public file: File;
  public idOperacaoEstadoOperacao: number;
  public idOperacaoScr: number;
  public idOperacaoDeslocarOperacao: number;
  public idOperacaoAjusteFatorK: number;
  public fatorK: number;
  public idEstado: number;
  public qtdMesesDeslocamento: number;
  public estados: Estado[] = [];
  public dataParcelaInadimplente: Date;
  public podeEditar: boolean;

  public idAditivo: number;
  public idEstadoAditivo: number;

  public numeroLiberacao: number;
  public idEstadoLiberacao: number;

  //---------Operação de Repasse--------//

  public sistemaCobranca: string;             //Obrigatório
  public contratoCobranca: number;        //Obrigatório
  public cnpjAgenteFinanceiro: string;  //Obrigatório
  public cnpjClienteFinal: string;
  public dataContratacao: Date;
  public dataPrimeiraAmortizacao:Date;
  public dataUltimaAmortizacao: Date;
  public valorOperacao: number;
  public idModalidadeOperacionalBndes: number;
  public idCodigoPrograma: number;

  constructor(
    private fileUtils: FileUtilsService,
    private service: TarefasOperacaoService,
    private messageService: MessageChannelService,
    private alertService: BnAlertsService,
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
    private permissaoService: PermissaoService,
    private loadingService: BnLoadingService) {

    this.estados = this.activatedRoute.snapshot.data['dominios'].estadosOperacao;
  }

  ngOnInit(): void {
  }

  public onFileChange(event) {

    this.conteudoArquivo = "";

    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];

      const reader = new FileReader();
      reader.readAsText(file, "UTF-8");
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          this.conteudoArquivo = reader.result;
        } else {
          this.conteudoArquivo = this.fileUtils.lerConteudo(reader);
        }
        this.file = file;
      };
    }
  }
  public contratoCobrancaLength() {
    if (this.contratoCobranca != null) {
      return this.contratoCobranca.toString().length < 11
    }
  }
  public habilitaBotao(){
    if(this.comparaDatas() || this.dataUltimaAmortizacao == null ||
    this.sistemaCobranca == null ||
    this.contratoCobranca == null ||
    this.cnpjAgenteFinanceiro ==null ||
    this.cnpjClienteFinal ==null ||
    this.dataContratacao == null ||
    this.valorOperacao == null)
    return true;
    else{
      return false;
    }
  }

  public comparaDatas() {
    if (this.dataPrimeiraAmortizacao != null && this.dataUltimaAmortizacao != null) {
      if (this.dataPrimeiraAmortizacao > this.dataUltimaAmortizacao
        || this.dataPrimeiraAmortizacao == this.dataUltimaAmortizacao) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return true;
    }
  }

  public importarOperacaoCreditoLivre() {
    if (this.file == null) {
      this.alertService.alertaErro('Erro', 'Nenhum arquivo carregado para importação');
    } else {
      this.loadingService.bloqueiaTela();
      this.service.importarOperacaoCreditoLivre(JSON.parse(this.conteudoArquivo)).subscribe(() => {
        this.messageService.addMessage({
          title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: 'Operação importada com sucesso.'
        });
        this.loadingService.liberaTela();
      }, (error) => { this.loadingService.liberaTela(); });
    }
  }

  public importarLiberacoes() {
    this.loadingService.bloqueiaTela();
    this.service
        .importarLiberacoes()
        .subscribe(() => {
          this.messageService.addMessage({
            title: "Sucesso",
            type: "CRUD_OPERATION",
            level: messageLevel.SUCCESS,
            message: "Importação finalizada",
          });
        });
    this.loadingService.liberaTela();
  }

  public importarOperacaoRepasse() {
    if (this.file == null) {
      this.alertService.alertaErro('Erro', 'Nenhum arquivo carregado para importação');
    } else {
      this.loadingService.bloqueiaTela();
      this.service.importarOperacaoRepasse(JSON.parse(this.conteudoArquivo)).subscribe(() => {
        this.messageService.addMessage({
          title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: 'Operação importada com sucesso.'
        })
        this.loadingService.liberaTela();
      }, (error) => { this.loadingService.liberaTela(); })
    }
  }

  public alterarEstadoOperacao() {
    if (this.idOperacaoEstadoOperacao == null || this.idEstado == null) {
      this.alertService.alertaErro('Erro', 'Preencha todos os campos para realizar a alteração');
    } else {
      this.loadingService.bloqueiaTela();
      this.service.alterarEstadoOperacao(this.idOperacaoEstadoOperacao, this.idEstado)
        .subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Estado da Operação alterado com sucesso'
          })
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); })
    }
  }

  public alterarFatorK() {
    if (this.idOperacaoAjusteFatorK == null || this.fatorK == null) {
      this.alertService.alertaErro('Erro', 'Preencha todos os campos para realizar a alteração');
    } else {
      this.loadingService.bloqueiaTela();
      this.service.alterarFatorK(this.idOperacaoAjusteFatorK, this.fatorK)
        .subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Fator K da Operação alterado com sucesso'
          })
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); })
    }
  }

  public alterarEstadoAditivo() {
    if (this.idAditivo == null || this.idEstadoAditivo == null) {
      this.alertService.alertaErro('Erro', 'Preencha todos os campos para realizar a alteração');
    } else {
      this.loadingService.bloqueiaTela();
      this.service.alterarEstadoAditivo(this.idAditivo, this.idEstadoAditivo)
        .subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Estado do aditivo alterado com sucesso'
          })
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); })
    }
  }

  public alterarEstadoLiberacao() {
    if (this.idOperacaoEstadoOperacao == null || this.numeroLiberacao == null || this.idEstadoLiberacao == null) {
      this.alertService.alertaErro('Erro', 'Preencha todos os campos para realizar a alteração');
    } else {
      this.loadingService.bloqueiaTela();
      this.service.alterarEstadoLiberacao(this.idOperacaoEstadoOperacao, this.numeroLiberacao, this.idEstadoLiberacao)
        .subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Estado da liberacao alterado com sucesso'
          })
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); })
    }
  }

  public criaScrValido() {
    if (this.idOperacaoScr == null || this.dataParcelaInadimplente == null) {
      this.alertService.alertaErro('Erro', 'Preencha todos os campos para realizar a criação do SCR Válido');
    } else {
      this.loadingService.bloqueiaTela();
      this.service.criarScrValido(this.idOperacaoScr, this.datePipe.transform(this.dataParcelaInadimplente, 'yyyy-MM-dd'))
        .subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'SCR Válido criado com sucesso'
          })
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); })
    }
  }

  public criaScrInvalido() {
    if (this.idOperacaoScr == null || this.dataParcelaInadimplente == null) {
      this.alertService.alertaErro('Erro', 'Preencha todos os campos para realizar a criação do SCR Inválido');
    } else {
      this.loadingService.bloqueiaTela();
      this.service.criarScrInvalido(this.idOperacaoScr, this.datePipe.transform(this.dataParcelaInadimplente, 'yyyy-MM-dd'))
        .subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'SCR Inválido criado com sucesso'
          })
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); })
    }
  }

  public efetivarContratacaoGarantiaCorte() {
    this.loadingService.bloqueiaTela();
    this.service.efetivarContratacaoGarantiaCorte().subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Contratação de garantia (corte) efetivada com sucesso'
      })
      this.loadingService.liberaTela();
    }, (error) => { this.loadingService.liberaTela(); })
  }

  public deslocarOperacaoNoTempo() {
    if (this.qtdMesesDeslocamento > 120 || this.qtdMesesDeslocamento < -120) {
      this.alertService.alertaErro('Erro', 'Qtde. meses deslocamento deve estar entre -120 e 120.');
    }
    else if (this.idOperacaoDeslocarOperacao == null || this.qtdMesesDeslocamento == null) {
      this.alertService.alertaErro('Erro', 'Preencha todos os campos para realizar o deslocamento da operação no tempo');
    } else {
      this.loadingService.bloqueiaTela();
      this.service.deslocarOperacaoNoTempo(this.idOperacaoDeslocarOperacao, this.qtdMesesDeslocamento)
        .subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Operacao realizada com sucesso. '
          })
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); }
        )
    }
  }

  public criarOperacaoDeRepasse() {
    if (this.sistemaCobranca == null || this.contratoCobranca == null || this.cnpjAgenteFinanceiro == null) {
      this.alertService.alertaErro('Erro', 'Preencha os campos obrigatórios');
    } else {
      this.loadingService.bloqueiaTela();
      let operacao = new OperacaoRepasseBndes();


      operacao.contratoCobranca = this.contratoCobranca;
      operacao.sistemaCobranca = this.sistemaCobranca;
      operacao.cnpjAgenteFinanceiro = this.cnpjAgenteFinanceiro;
      operacao.cnpjClienteFinal = this.cnpjClienteFinal;
      operacao.dataContratacao = this.dataContratacao;
      operacao.dataPrimeiraAmortizacao = this.dataPrimeiraAmortizacao;
      operacao.dataUltimaAmortizacao = this.dataUltimaAmortizacao;
      operacao.valorOperacao = this.valorOperacao;
      operacao.idCodigoPrograma = this.idCodigoPrograma;
      operacao.idModalidadeOperacionalBndes = this.idModalidadeOperacionalBndes;

      console.log("Antes de chamar o serviço: " + JSON.stringify(operacao))

      this.service.criarOperacaoDeRepasse(operacao)
        .subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Operação criada com sucesso.'
          })
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); })
      console.log("Depois de chamar o serviço: " + JSON.stringify(operacao))

    }
  }
  public criarJson() {
    if (this.jsonOperacao == null) {
      this.alertService.alertaErro('Erro', 'Preencha os campos obrigatórios');
    } else {
      this.loadingService.bloqueiaTela();
      this.service.criarOperacaoDeRepassePorJson(this.jsonOperacao)
        .subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Operação de Repasse criada com sucesso.'
          })
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); })


    }
  }

  // JSON de exemplo para uso na API de tarefas - aplicavel apenas a testes em DSV/HOM
  private jsonOperacao = `
  {
     "idProtocoloBNDES": "OPE-TST-REP-100",
    "codigoTipoOperacao": "R",
    "idNaturezaEmpresa": 2062,
    "cnpjAgenteFinanceiro": "00000000000191",
    "cnpjClienteFinal": "56720428001488",
    "ideCustoFinanceiroProtocolo": 777,
    "riscoOperacao": "A",
    "percentualGarantido": 80,
    "valorOperacao": 5000,
    "cnaeClienteFinal": "C2829199",
    "dataContratacao": "2020-07-01",
    "idPrograma": 450081,
    "idModalidadeOperacionalBndes": 24000,
    "idPorteClienteFinal": "4",
    "tipoFGI": "4",
    "idComplementoNaturezaEmpresa": null,
    "quantidadeMesesPrazoTotal": 63,
    "quantidadeMesesPrazoCarencia": 6,
    "dataEnvio": null,
    "detalhe": null,
    "numeroCertificadoRntrc": null,
    "sistemaCobranca": 15,
    "contratoCobranca": 30215288507,
    "dataPrimeiraAmortizacao": "2021-05-15",
    "dataUltimaAmortizacao": "2023-09-15",
    "taxaSpreadAgente": 2,
    "taxaRemuneracaoBNDES": 1.15,
    "taxaIntermediacaoBNDES": 0.15,
    "taxaRemuneracaoBasicaBNDES": 1,
    "taxaCustoFinanceiroAdicional": 0,
    "taxaReferencialCustoFinanceiro": null,
    "tipoReceitaBruta": "E",
    "receitaBrutaClienteFinal": 400000.00,
    "dataReferenciaReceitaBruta": "2019-12-31",
    "reprocessamento": "false"
  }
 `
  public limpar() {
    this.sistemaCobranca = null;
    this.contratoCobranca = null;
    this.dataParcelaInadimplente = null;
    this.idOperacaoDeslocarOperacao = null;
    this.dataContratacao = null;
    this.dataPrimeiraAmortizacao = null;
    this.dataUltimaAmortizacao = null;
    this.valorOperacao = null;
    this.cnpjAgenteFinanceiro = null;
    this.cnpjClienteFinal = null;
  }
  public limparJson(){
    this.jsonOperacao = null;
  }

  limparEstadoOperacao(){
    this.idOperacaoEstadoOperacao = null;
    this.idEstado = null;
  }

  limparAlteracaoFatorK() {
    this.idOperacaoAjusteFatorK = null;
    this.fatorK = null;
  }

  limparEstadoAditivo(){
    this.idAditivo = null;
    this.idEstadoAditivo = null;
  }

   limparEstadoLiberacao(){
    this.idOperacaoEstadoOperacao = null;
    this.numeroLiberacao = null;
    this.idEstadoLiberacao = null;
  }

  limparScr(){
    this.idOperacaoScr = null;
    this.dataParcelaInadimplente = null;

  }

  limparDeslocarOperacao(){
    this.idOperacaoDeslocarOperacao = null;
    this.qtdMesesDeslocamento = null;
  }

  limparOperacaoRepasse(){
    this.sistemaCobranca = null;
    this.contratoCobranca = null;
    this.cnpjAgenteFinanceiro = null;
    this.cnpjClienteFinal = null;
    this.dataContratacao = null;
    this.dataPrimeiraAmortizacao = null;
    this.dataUltimaAmortizacao = null;
    this.valorOperacao = null;
  }

}
